import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Flex, Button, Text, Table, Thead, Tbody, Tr, Th, Td, Input, Select, HStack, IconButton, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, VStack, FormControl, FormLabel, Badge, useBreakpointValue, Card, CardBody, useDisclosure } from "@chakra-ui/react";
import { FaPlus, FaEdit, FaTrash, FaArrowLeft } from 'react-icons/fa';

export default function MasterAktifitas({ onBack }) {
  const toast = useToast();
  const [aktifitas, setAktifitas] = useState([]);
  const [selected, setSelected] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [form, setForm] = useState({ nama_aktifitas: '', met: '', kategori: 'ringan' });

  const showToast = (title, status = 'info') => {
    toast({ title, status, duration: 3000, isClosable: true, position: 'top' });
  };

  const loadAktifitas = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}/get-activities`);
      setAktifitas(res.data || []);
    } catch (err) {
      showToast('Gagal load aktifitas', 'error');
    }
  };

  useEffect(() => { loadAktifitas(); }, []);

  const openEdit = (item) => {
    setSelected(item);
    setForm(item);
    onOpen();
  };

  const handleSave = async () => {
    if (!form.nama_aktifitas || !form.met) return showToast('Nama + MET wajib', 'warning');
    try {
      if (selected) {
        await axios.post(`${process.env.REACT_APP_API_BASE}/update-activity`, { id: selected.id, ...form });
        showToast('Aktifitas diupdate', 'success');
      } else {
        await axios.post(`${process.env.REACT_APP_API_BASE}/add-activity`, form);
        showToast('Aktifitas ditambah', 'success');
      }
      onClose();
      setForm({ nama_aktifitas: '', met: '', kategori: 'ringan' });
      setSelected(null);
      loadAktifitas();
    } catch (err) {
      showToast(err.response?.data?.message || 'Gagal simpan', 'error');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Hapus aktifitas ini?')) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE}/delete-activity?id=${id}`);
      showToast('Aktifitas dihapus', 'success');
      loadAktifitas();
    } catch (err) {
      showToast('Gagal hapus', 'error');
    }
  };

  return (
    <Box p={{ base: 2, md: 4 }}>
      <Flex justify="space-between" mb={4} align="center">
        <Button leftIcon={<FaArrowLeft />} onClick={onBack} variant="ghost" size="sm">Kembali</Button>
        <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="bold">Master Aktifitas</Text>
        <Button leftIcon={<FaPlus />} colorScheme="orange" size="sm" onClick={() => {
          setSelected(null);
          setForm({ nama_aktifitas: '', met: '', kategori: 'ringan' });
          onOpen();
        }}>Tambah Aktifitas</Button>
      </Flex>

      <Box overflowX="auto" borderWidth="1px" borderRadius="lg">
        <Table size="sm">
          <Thead bg="gray.50">
            <Tr>
              <Th>ID</Th><Th>Nama Aktifitas</Th><Th>MET</Th><Th>Kategori</Th><Th>Aksi</Th>
            </Tr>
          </Thead>
          <Tbody>
            {aktifitas.map(a => (
              <Tr key={a.id}>
                <Td>{a.id}</Td>
                <Td fontWeight="semibold">{a.nama_aktifitas}</Td>
                <Td>{a.met}</Td>
                <Td><Badge colorScheme={a.kategori==='berat'?'red':a.kategori==='sedang'?'yellow':'green'}>{a.kategori}</Badge></Td>
                <Td>
                  <HStack spacing={1}>
                    <IconButton icon={<FaEdit />} size="xs" onClick={() => openEdit(a)} />
                    <IconButton icon={<FaTrash />} size="xs" colorScheme="red" onClick={() => handleDelete(a.id)} />
                  </HStack>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size={isMobile? 'full' : 'md'}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{selected? 'Edit' : 'Tambah'} Aktifitas</ModalHeader>
          <ModalBody>
            <VStack spacing={3}>
              <FormControl isRequired>
                <FormLabel>Nama Aktifitas</FormLabel>
                <Input value={form.nama_aktifitas} onChange={e => setForm({...form, nama_aktifitas: e.target.value})} placeholder="Contoh: Jalan santai" />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>MET</FormLabel>
                <Input type="number" step="0.1" value={form.met} onChange={e => setForm({...form, met: e.target.value})} placeholder="Contoh: 3.5" />
              </FormControl>
              <FormControl>
                <FormLabel>Kategori</FormLabel>
                <Select value={form.kategori} onChange={e => setForm({...form, kategori: e.target.value})}>
                  <option value="ringan">Ringan</option>
                  <option value="sedang">Sedang</option>
                  <option value="berat">Berat</option>
                </Select>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose} mr={3}>Batal</Button>
            <Button colorScheme="orange" onClick={handleSave}>Simpan</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}